import { IbloqueioUsuarioUseCase } from "../../../presentation/useCases/update/bloqueio_usuario_use_case";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * bloqueioUsuarioUseCase
 */

export class bloqueioUsuarioUseCase implements IbloqueioUsuarioUseCase {
  constructor(private readonly repository: IAdministracaoRepository) { }

  async execute(idUsuario: number): Promise<void> {
    await this.repository.bloqueioUsuarioById(idUsuario);
  }
}
